import React from "react";
import { HiddenRadio, RadioLabel } from "./Radio.styled";

/**
 * A custom radio input component that provides a styled radio button with a label.
 * 
 * @component
 * @param {Object} props - The component props
 * @param {string} props.label - The text label to display next to the radio button
 * @param {string} [props.name] - The name attribute for the radio input
 * @param {string} [props.value] - The value attribute for the radio input
 * @param {boolean} [props.checked] - Whether the radio button is checked
 * @param {boolean} [props.disabled] - Whether the radio button is disabled
 * @param {function} [props.onChange] - Callback function that is called when the radio button's value changes
 * @param {function} [props.onBlur] - Callback function that is called when the radio button loses focus
 * @param {function} [props.onFocus] - Callback function that is called when the radio button gains focus
 * @param {string} [props.className] - Additional CSS class names to apply to the radio button wrapper
 * 
 * @example
 * // Basic usage
 * <Radio label="Option 1" name="options" value="1" onChange={handleChange} />
 * 
 * // Disabled state
 * <Radio label="Disabled Option" disabled={true} />
 * 
 * @returns {JSX.Element} A styled radio button with a label
 */
const Radio = ({ label, ...props }) => (
  <RadioLabel>
    <HiddenRadio {...props} />
    {label}
  </RadioLabel>
);

export default Radio;